import React from 'react';

import styles from './StackedPill.module.scss';

interface SegmentDataset {
  data: number[];
  backgroundColor: string;
  [key: string]: any;
}

interface StackedPillProps {
  data: {
    labels: string[];
    datasets: SegmentDataset[];
  };
}

export const StackedPill: React.FC<StackedPillProps> = ({ data }) => {
  const segments = data.datasets.filter(d => d.data[0] > 0);

  return (
    <div className={styles.wrapper}>
      <div className={styles.bar}>
        {segments.map(segment => (
          <div
            key={segment.backgroundColor}
            className={styles.segment}
            style={{
              flex: segment.data[0],
              backgroundColor: segment.backgroundColor,
            }}
          />
        ))}
      </div>
      <div className={styles.labels}>
        {segments.map(segment => (
          <div
            key={segment.backgroundColor}
            className={styles.label}
            style={{ flex: segment.data[0] }}
          >
            {segment.data[0].toFixed(2)}%
          </div>
        ))}
      </div>
    </div>
  );
};
